import Empresa from './empresa-node.dto'

class ListaEmpresaDto {
    private static instance: ListaEmpresaDto

    public empresaSelecionada: any = Empresa

    public empresas: Array<Empresa> = []

    public static getInstance(): ListaEmpresaDto {
        if (!ListaEmpresaDto.instance) {
            ListaEmpresaDto.instance = new ListaEmpresaDto()
        }

        return ListaEmpresaDto.instance
    }
}

export { ListaEmpresaDto }
export default ListaEmpresaDto
